
import { CommonStateEnum } from "./common";
import { Org } from "./org";

export enum AreaEnum {
	CN = '+86', // 中国
	SG = '+65', // 新加坡
	HK = '+852', // 香港
	TW = '+886', // 台湾
	VN = '+84', // 越南
	IN = '+62', // 印度尼西亚
	MA = '+60', // 马来西亚
	BHR = '+973', // 巴林
}

export enum UserSettingEnum {
	LANG = 1,
	THEME
}

export type AreaCodeInfo = Array<{
	area: string;
	reg: RegExp;
	tip: string;
	code: AreaEnum;
}>;

export interface UserPermission {
	orgId: string | null;
	userId: string;
	permission: UserPermissionEnum;
}

export interface UserSetting {
	type: UserSettingEnum;
	value: UserLangEnum | string;
}

export interface User {
	id: string;
	areaCode: AreaEnum;
	mobile: string;
	name1: string;
	name2: string;
	avatar: string;
	logBookId: string;
	orgs: Array<Org>;
	permissions: Array<UserPermission>;
	settings: Array<UserSetting>;
	state: CommonStateEnum
}

export interface UserAdd {
	name1?: string;
	name2?: string;
	avatar?: string;
	areaCode: AreaEnum | '';
	mobile: string;
}

export interface UserUpdate {
	name1?: string;
	name2?: string;
	avatar?: string;
	areaCode: AreaEnum;
	mobile: string;
}

export interface UserUpdatePermission {
	orgId: string | null;
	permissions: Array<UserPermissionEnum>;
}

export enum UserLangEnum {
	ZH = '1',
	EN = '2',
	TR = '3',
	VN = '4',
	KO = '5'
}

export enum UserPermissionEnum {
	ADMIN,

	SALE_REVIEW, // 销售管理 - 评审单
	SALE_OK_ORDER, // 销售管理 - 正式订单
	SALE_CUSTOMER, // 销售管理 - 终端客户管理
	MC_REQUIREMENT, // 物控 - 需求评审
	MC_OK_ORDER, // 物控 - 正式订单
	MC_BOM, // 物控 - BOM 管理
	PR_REQUIREMENT, // 生产 - 需求评审
	PR_OK_ORDER, // 生产 - 正式订单
	PR_REPORT_ENTRY, // 生产 - BOM 管理
	PR_REPORT_MT, // 生产数据维护
	PUR_REQUIREMENT, // 采购管理 - 需求评审
	PUR_OK_ORDER, // 采购管理 - 正式订单
	PUR_SUPPLIER, // 采购管理 - 供应商管理
	PUR_PRICES, // 采购管理 - 报价列表
	PUR_ORDER, // 采购管理 - 采购订单管理
	FINANCE_REQUIREMENT, // 财务管理 - 需求评审
	FINANCE_OK_ORDER, // 财务管理 - 正式订单
	DATA_ORDER_REPORT, // 数据模块 - 订单报表
	ORG_PREVIEW, // 组织管理 - 查看当前组织
	ORG_ADD, // 组织管理 - 添加跟组织
	MEMBER_LIST,
	PRODUCT_ADD_CATEGORY_LIST, // 商品类目/商品管理
	PRODUCT_CATEGORY_EDIT_INFO, // 修改商品类目信息
	PRODUCT_CATEGORY_ADD_OR_EDIT, // 新增/修改类目商品
	PRODUCT_LIST, // 商品列表
	PRODUCT_ADD, // 新增商品
	APP_LIST, // APP管理

	STORE_LIST, // 仓储管理 - 组织仓库
	STORE_ORDER, // 仓储管理 - 订单列表
	STORE_COUNTING, // 仓储管理 - 盘点历史
	STORE_ORDER_MANAGE, // 仓储管理 - 订单管理

	PUR_ORDER_ADD, // 采购管理 - 添加采购订单

	ACT_STORE_IN, // 本仓库操作: 入库
	ACT_STORE_OUT, // 本仓库操作: 出库
	ACT_STORE_COUNTING, // 本仓库操作: 盘点
	ACT_ORG_EDIT, // 组织信息修改
	ACT_ORG_EDIT_MEM, // 组织成员修改

	PUR_REQUIREMENT_ORDER, // 需求单生成采购单
	DATA_MANAGE_SUPPLIER,	//数据管理（供应商管理）

	PUR_ORDER_EDIT, // 采购管理 - 修改采购订单
	PUR_HELP_ACCEPT, // 采购订单管理 - 协助接受

	PUR_QUO_PRO_LIST,	//报价商品列表
	PUR_QUO_MAN,	//报价管理

	SETTINGS_PRINTING,	//打印设置
	SETTINGS_QUO_TYPE,	//报价类目管理
	SETTINGS_CURR,	//汇率设置
	SETTINGS_ADDRESS,	//汇率设置

	CMD_REQUIREMENT,	//产品需求清单
	CMD_OK_ORDER,		//产品订单追踪

	PDA_PRINT_PUR,	//pda打印采购单

	PURCHASE_OPTION,		//采购操作
	PURCHASE_OPTION_MANUAL,
	PURCHASE_MATERIAL_TRACK,
	PURCHASE_RETURN,

	REQ_MANAGE,	//需求清单管理
	SALES_PRODUCT_INFO,	//生产资料

	PRODUCT_CATEGORY_ORG_SET,		//设置商品分类权限

	STORE_WAREHOUSE_PREPARATION, // 仓储管理 - 出入库准备
	STORE_WAREHOUSE_MANAGEMENT, // 仓储管理 - 出入库管理
	STORE_LOCATION_MANAGEMENT, // 仓储管理 - 库位管理
	STORE_COUNTING_HISTORY, // 仓储管理 - 盘点历史菜单
	STORE_LOCATION_REF_PRODUCTS, // 仓储管理 - 库位商品关联

	REIMBUERSE_CATEGORY,		//设置报销分类权限
	APPROVE_TEMPLATE_SET,		//设置审批模版
	REIMBURSE_ALL,		//所有报销数据
	WAREHOUSE_INVENTORY_DETAIL,		//出入库明细
	WAREHOUSE_IQC,		//质检单列表
	MATERIAL_INVENTORY_ALERT, 	//库存预警
	MATERIAL_INVENTORY_ALERT_SET, 	//设置库存预警
	OTHER_OUTBOUND,	//其他出库
	TEMP_INBOUND,		//临时入库
	TEMP_INBOUND_PRODUCT,		//临时生产入库
	SAEL_OUTBOUND,		//销售出库
	PRINT_RULE_SETTING,	//采购条约设置
	FAC_INVENTORY,		//产险仓库页面
	PACKING,		//出库装箱
	SHIPMENT_LIST,		//运输管理 - 运输订单
	EQUIPMENT_MANAGEMENT,		//设备管理 - 页面查看
	EQUIPMENT_CATEGORY_ADD_OR_EDIT,		//设备管理 - 新增/编辑设备类目
	EQUIPMENT_ADD_OR_EDIT,		//设备管理 - 新增/编辑设备信息
	MC_REQ_M,		//备料计划
	INSPECTION,		//仓储巡检
	INSP_CONFIG_PRO,		//仓储巡检物料配置
	INSP_ITEM,		//仓储巡检项
	PUR_INV_ITEM,		//采购送货单明细
	FINANCE_SALE_ORDER_FINISH, // 财务管理 - 销售订单完结
	LOC_INV_DTL,		//库位出入库明细
	SALE_TO_OFFICIAL,		//销售管理 - 评审单转正式订单
}
